// w3.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W3 = () => {
  return <WW config={pageConfigs.w3} />;
};

export default W3;
